<template lang="pug">
    v-autocomplete(dense
        v-model.trim="data"
        :disabled="disabled"
        :readonly="readonly"
        :items="listMerchant"
        :required="required"
        :rules="rules"
        :label="label"
        item-value="merchantId"
        item-text="merchantName"
        @change="onSelect")
        template(v-slot:prepend v-if="template")
            v-icon(color="success") mdi-checkbox-marked-outline
        template(v-slot:item="data")
            label {{data.item.virtualAccountPrefix ? data.item.virtualAccountPrefix : ""}}{{data.item.merchantId}} - {{data.item.merchantName}}
        template(v-slot:selection="data")
            label {{data.item.virtualAccountPrefix ? data.item.virtualAccountPrefix : ""}}{{data.item.merchantId}} - {{data.item.merchantName}}
</template>
<script>
export default {
    name: "FSelectTransactionMerchant",
    props: [
        "value", 
        "disabled", 
        "readonly", 
        "label",
        "rules",
        "required",
        "template"
    ],
    data() {
        return {
            data : null,
            listData: []
        };
    },
    computed: {
        listMerchant(){
            return this.listData.filter(f => f.merchantType != 'DBCR');
        }
    },
    mounted() {
        this.data = this.value;
    },
    watch: {
        value(val) {
            this.data = val ? val.trim() : val;
        }
    },
    methods: {
        onSelect() {
            this.$emit("input", this.data);
            this.$emit("select", this.data);
            this.$emit("merchant", this.merchantValue());
        },
        merchantValue() {
            let result = "";
            this.listData.map(element => {
                if (this.data === element.merchantId) {
                    result = element;
                }
            });
            return result;
        }
    },
    created() {
        this.$http.get("api/virtual-account/merchant/list").then(success => {
            this.listData = success.data;
        });
    }
}
</script>